/**
 * Hook que integra o ErrorLogger com o AuthContext
 * Garante que os logs de erro tenham os dados corretos do usuário
 */

import { useAuth } from "../contexts/AuthContext";
import { useErrorLogger } from "../services/errorLogService";

export const useErrorLoggerWithAuth = () => {
  const { currentUser, churchUser } = useAuth();

  // Criar objeto com dados do usuário para passar ao ErrorLogger
  const userInfo = currentUser
    ? {
        uid: currentUser.uid,
        email: currentUser.email,
        membroId: churchUser?.membroId,
        displayName: currentUser.displayName,
        role: churchUser?.role,
      }
    : null;

  const errorLogger = useErrorLogger(userInfo);

  return {
    ...errorLogger,
    userInfo, // Exportar também os dados do usuário para debug
  };
};

export default useErrorLoggerWithAuth;
